/**
 * cookies操作
 */

const trim = (str) => {
    return str ? str.replace(/(^[ \t\n\r]+)|([ \t\n\r]+$)/g, '') : '';
}

const getKeyValue = (from, elemTag, kvTag, key) => {
    var _d = decodeURIComponent, arr = from.split(elemTag), i, l, ret = {};
    for (i = 0, l = arr.length; i < l; i++) {
        var tmp = arr[i].split(kvTag), k = _d(trim(tmp[0]));
        if (!k) {
            continue;
        }
        if (k in ret) {
            if (!(ret[k] instanceof Array)){
                ret[k] = [ret[k]];
            }
            ret[k].push(_d(tmp[1]));
        } else {
            ret[k] = _d(tmp[1]);
        }
    }
    if (key) {
        return key in ret ? ret[key] : null;
    }
    return ret;
}

/**
 * 转化成cookie格式的字符串
 * @param {Object} from
 */
const toCookieFormatString = (from) => {
    let _e = encodeURIComponent;
    if (typeof from != 'object') {
        throw new Error('serial.u_wrongTypeForCookieFormatString');
    }
    if (!('name' in from)) {
        throw new Error('serial.u_keyOfNameLost');
    }
    var name = _e(from.name), value;
    if (!('value' in from) || from.value === null) {
        value = '';
        from.expires = -1;
    } else {
        value = _e(from.value);
    }
    var expires = '';
    if (from.expires && (typeof from.expires == 'number' || from.expires.toUTCString)) {
        var date;
        if (typeof from.expires == 'number') {
            date = new Date();
            if (from.expires < Math.pow(2,9)) {
                date.setTime(date.getTime() + (from.expires * 24 * 60 * 60 * 1000));
            } else if (from.expires < Math.pow(2,32)) {
                date.setTime(from.expires * 1000);
            } else {
                date.setTime(from.expires);
            }
        } else {
            date = from.expires;
        }
        expires = '; expires=' + date.toUTCString();
    }
    var path = from.path ? '; path=' + (from.path) : '',
        domain = from.domain ? '; domain=' + (from.domain) : '',
        secure = from.secure ? '; secure' : '';
    return [name, '=', value, expires, path, domain, secure].join('');
}

/**
 * 获取所有网页参数
 * @return {array}
 */
const getCookieAll = ()=>{
    return getKeyValue(document.cookie, ';', '=');
} 

/**
 * 获取cookie值
 * @param {String} key
 */
const getCookie =  (key)=> {
    var cs = getCookieAll();
    return cs[key];
}

/**
 * 设置cookie值
 * @function setCookie
 * @param {String} key 名称
 * @param {String} value 值
 * @param {Date | Number} expire 过期时间。如果是Number，< 512(2 << 9)，表示距离当前时间的天数; < 4294967295 (2 << 32)，表示单位为s的时间戳对应；更大的则表示单位为ms的时间戳
 * @param {String} path 路径
 * @param {String} domain 域名
 * @param {Boolean} secure 是否安全
 */
const setCookie = (key, value, expire, path, domain, secure)=>{
    document.cookie = toCookieFormatString({
        name: key,
        value: value,
        expires: expire,
        path: path,
        domain: domain,
        secure: secure
    });
}

const delCookie = (key,path,domain)=> {
    setCookie(key, '', -1, path,domain);
}

export  {
    getCookie,
    setCookie,
    delCookie,
    getCookieAll
}